import { DataModel } from "common/models/utility-models/base-model";

export class MentorFeedbackModel extends DataModel {
    // mentorFeedback:string = '';
    questions: any = [];
    studentsList: any = [];
    selectStatus: any = '';
    selectStudent: any = '';
}